
import { Component, Prop, Provide, Vue } from 'vue-property-decorator'

@Component
export default class OtherParams extends Vue {
    $refs!: { dataTable: any };
    visible = {
        val: false
    }
    @Provide('visible')
    visibleVal = this.visible
    // props
    @Prop({ default: '' }) title!: string //弹窗标题
    @Prop({ default: '确认' }) confirmButtonText!: string //确认按钮内容
    @Prop({ default: '取消' }) cancelButtonText!: string | boolean //取消按钮内容
    @Prop({ default: false }) async!: boolean //是否开启异步关闭
    @Prop({ default: true }) clickModalClose!: boolean // 点击遮罩层关闭对话窗口
    @Prop({ default: [] }) value!: any[]
    // data
    modelOtherParams = [
        // { label: '深度写入', key: 'depth_write', value: 1, type: 'radio', options: [{ label: '是', value: 1 }, { label: '否', value: 0 }], desc: '控制此材质是否影响深度缓冲区。默认值为true。当绘制透明物体时，我们通常需要将后面的物体也绘制出来，所以有时需要将depthWrite设置为false，以避免透明物体阻挡后面的物体' },
        // { label: 'alpha_test', key: 'alpha_test', value: 0.1, type: 'number', desc: '它是一个阈值，范围在0到1之间。当片元的alpha值小于这个阈值时，该片元将被丢弃（不渲染）' },
        { label: '金属度', key: 'metalness', value: 0, type: 'number', desc: '0.0（完全不金属，漫反射为主）到 1.0（完全金属，镜面反射为主）' },
        { label: '粗糙度', key: 'roughness', value: 0.5, type: 'number', desc: '0.0（完全光滑，镜面反射）到 1.0（完全粗糙，漫反射为主），粗糙度会影响环境贴图的反射模糊度' },
        { label: '透射', key: 'transmission', value: 1, type: 'number', desc: '控制光线穿过材质的比例，用于模拟玻璃、水等透明介质的透光效果' },
        { label: '折射率', key: 'ior', value: 1, type: 'number', desc: '控制光线在材质中的反射和折射，用于模拟不同材质的折射和反射效果' },
        { label: '厚度', key: 'thickness', value: 2, type: 'number', desc: '控制材质的厚度，用于模拟不同材质的厚度效果' },
    ]
    selected: any = []
    // methods

    handleSelectionChange(val: any[]) {
        this.selected = val
    }

    handleEvent(type: 'cancel' | 'confirm') {
        this.$emit(type)
        if (!this.async || type === 'cancel') this.close()
        this.$emit('change', this.selected)
    }

    onTrigger() {

        this.open()
    }

    close() {
        this.visible.val = false
        this.$emit('close')
    }
    async open() {
        this.visible.val = true
        this.$emit('open')
        await this.$nextTick()
        if (this.value.length > 0) {
            this.modelOtherParams.forEach((item: any) => {
                const found = this.value.find((val: any) => val.key === item.key)
                if (found) {
                    this.$refs.dataTable.toggleRowSelection(item, true)
                }
            })
        }
    }
}
